import { createRoot } from "react-dom/client";

import "./instrument";
import "./index.css";
import App from "./App";
import { initializeTheme } from "./utils/theme-manager";
import * as Sentry from "@sentry/react";

initializeTheme();

createRoot(document.getElementById("root")!, {
  onUncaughtError: Sentry.reactErrorHandler((error, errorInfo) => {
    console.warn("Uncaught error:", error, errorInfo.componentStack);
  }),
  // Callback called when React catches an error in an ErrorBoundary.
  onCaughtError: Sentry.reactErrorHandler(),
  // Callback called when React automatically recovers from errors.
  onRecoverableError: Sentry.reactErrorHandler(),
}).render(<App />);
